/**
 * Divider Component
 * Horizontal divider with optional label
 * WCAG 2.1 AA compliant
 */

import React from 'react';

export interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  spacing?: 'sm' | 'md' | 'lg';
}

const spacingClasses = {
  sm: 'my-2',
  md: 'my-4',
  lg: 'my-8',
};

export const Divider: React.FC<DividerProps> = ({
  label,
  spacing = 'md',
  className = '',
  ...props
}) => {
  if (label) {
    return (
      <div className={`relative ${spacingClasses[spacing]} ${className}`} {...props}>
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-neutral-200" />
        </div>
        <div className="relative flex justify-center">
          <span className="bg-white px-3 text-sm text-neutral-500">{label}</span>
        </div>
      </div>
    );
  }

  return (
    <hr
      className={`border-0 border-t border-neutral-200 ${spacingClasses[spacing]} ${className}`}
      role="presentation"
      {...props}
    />
  );
};
